{
    "purchaseOrder": "Purchase order",
    "columns": {
        "columns": "Columns",
        "name": "Name",
        "requester": "Requester",
        "vendor": "Vendor",
        "dateOfIssue": "Order date",
        "createdAt": "Order date",

        "deliveryStatus": "Delivery status",
        "invoicedStatus": "Invoice status",
        "amount": "Amount",
        "status": "Status",
        "action": "Actions"
    },
    "list": {
        "title": "Purchase orders",
        "columns": "Columns"
    },

    "actionButtons": {
        "SUBMIT_FOR_APPROVAL": "Submit for approval",
        "APPROVE": "Approve",
        "SUBMIT_FOR_FULFILLMENT": "Release order",
        "CREATE_CARD": "Create card",
        "CLOSE_PURCHASE_ORDER": "Order complete"
    },
    "actionButtonsReject": {
        "SUBMIT_FOR_APPROVAL": "Reset for approval",
        "DENY": "Reject"
    },
    "actionButtonsPrevious": {
        "200_SUBMIT_FOR_REDO": "Request Changes",
        "300_SUBMIT_FOR_REDO": "Reset for approval"
    },
    "actionTitles": {
        "100": "Request is a draft.",
        "200": "Approve this request?",
        "200__not_approver": "Approval pending",
        "300": "Procurement review needed.",
        "400": "Waiting for confirmation."
    },
    "actionSubtitles": {
        "100": "Before you submit check if all info is correct.",
        "200": "Make sure the order fits the budget.",
        "200__not_approver": "The approver needs to approve the request.",
        "300": "Make sure this order meets the guidelines.",
        "400": "Mark the order complete after all items are delivered and invoiced."
    },
    "rejection_note": {
        "title": "Rejection explanation",
        "message": "Please tell us why you are rejecting this purchase order",
        "placeholder": "Reason for rejection",
        "confirm": "Reject",
        "cancel": "Cancel"
    },
    "request_changes": {
        "title": "Warning",
        "message": "If you request changes on this purchase order, the approval process will be reset, and all approvals done on it will be lost. Would you like to continue?",
        "placeholder": "What changes are you requesting?",
        "confirm": "Yes",
        "cancel": "No"
    },

    "deliveryStatus": {
        "short": {
            "fullyDelivered": "Delivered",
            "partiallyDelivered": "Part. delivered",
            "notDelivered": "Not delivered",
            "none": "None"
        },
        "full": {
            "fullyDelivered": "Fully delivered",
            "partiallyDelivered": "Partially delivered",
            "notDelivered": "Not delivered",
            "none": "None"
        }
    },
    "invoicedStatus": {
        "short": {
            "fullyInvoiced": "Invoiced",
            "partiallyInvoiced": "Part. invoiced",
            "notInvoiced": "Not invoiced"
        },
        "full": {
            "fullyInvoiced": "Fully invoiced",
            "partiallyInvoiced": "Partially invoiced",
            "notInvoiced": "Not invoiced"
        }
    },
    "details": {
        "title": "Purchase order",
        "vat": "VAT %",
        "totalVatAmount": "Total VAT amount",
        "costCenter": "Cost center",
        "costUnit": "Cost unit",
        "costCenter2": "Cost center 2",
        "expenseAccount": "Expense account",
        "quantity": "Quantity",
        "quantityReceived": "Quantity received",
        "totalNet": "Total net",
        "totalGross": "Total gross",
        "totalAmountInvoiced": "Total amount invoiced",
        "deliveryNotes": "Delivery notes",
        "invoices": "Invoices",
        "addDeliveryNote": "Add delivery note",
        "addInvoice": "Add document",
        "orDropFilesToUpload": "or drop files to upload",
        "purchaseOrderDocument": "Purchase order document",
        "purchaseDetails": "Purchase details",
        "comments": "Comments",
        "None": "None",
        "Complete": "Complete",
        "Partial": "Partial",
        "totalTax": "Total VAT"
    },
    "unitOfMeasure": {
        "pcs": "Piece (pcs)",
        "doz": "Dozen (doz)",
        "pr": "Pair (pr)",
        "set": "Set (set)",
        "pk": "Pack (pk)",
        "bx": "Box (bx)",
        "bdl": "Bundle (bdl)",
        "rl": "Roll (rl)",
        "mg": "Milligram (mg)",
        "g": "Gram (g)",
        "kg": "Kilogram (kg)",
        "oz": "Ounce (oz)",
        "lb": "Pound (lb)",
        "t": "Ton (t)",
        "ton": "Ton (ton)",
        "mm": "Millimeter (mm)",
        "cm": "Centimeter (cm)",
        "m": "Meter (m)",
        "km": "Kilometer (km)",
        "in": "Inch (in)",
        "ft": "Foot (ft)",
        "yd": "Yard (yd)",
        "mi": "Mile (mi)",
        "ml": "Milliliter (ml)",
        "l": "Liter (L)",
        "cm3": "Cubic centimeter (cm³)",
        "m3": "Cubic meter (m³)",
        "fl_oz": "Fluid ounce (fl oz)",
        "gal": "Gallon (gal)",
        "s": "Second (s)",
        "min": "Minute (min)",
        "h": "Hour (h)",
        "day": "Day",
        "week": "Week",
        "month": "Month",
        "year": "Year",
        "j": "Joule (J)",
        "kj": "Kilojoule (kJ)",
        "cal": "Calorie (cal)",
        "kcal": "Kilocalorie (kcal)",
        "wh": "Watt-hour (Wh)",
        "kwh": "Kilowatt-hour (kWh)",
        "w": "Watt (W)",
        "kw": "Kilowatt (kW)",
        "hp": "Horsepower (hp)",
        "celsius": "Celsius (°C)",
        "fahrenheit": "Fahrenheit (°F)",
        "kelvin": "Kelvin (K)"
    },
    "drawer": {
        "newPurchaseOrder": "New purchase order",
        "editPurchaseOrder": "Edit purchase order",
        "poNumber": "PO number",
        "vendor": "Vendor",
        "dateOfIssue": "Date of issue",
        "description": "Description",
        "createCard": "Create card",
        "cardTooltip": "Please activate if your order is for a service.",
        "service": "Service",
        "letUsKnowIfYourOrderIsForPhysicalGoodsOrAService": "Please activate if your order is for a service.",
        "addTag": "Add tag",
        "performancePeriod": "Performance period",
        "performanceDate": "Performance date",
        "deliveryDate": "Planned delivery date",
        "expenseAccount": "Expense account",
        "currency": "Currency",
        "selectCurrency": "Select currency",
        "totalNet": "Total net",
        "totalVat": "Total VAT",
        "vat": "VAT",
        "totalGross": "Total gross",
        "lineItems": "Line items",
        "quantity": "Quantity",
        "unit": "Unit",
        "unitPrice": "Unit price",
        "taxRate": "Tax rate",
        "materialCode": "Material code",
        "link": "Link",
        "note": "Note",
        "addItem": "Add item",
        "nextApprover": "Next approver",
        "requester": "Requester",
        "selectNextApprover": "Select next approver",
        "saveAsDraft": "Draft",
        "submitOrder": "Submit order",
        "clickToUploadOrDragAndDropFilesHere": "Click to upload or drag and drop files here",
        "supportsPdfImagesAndOtherDocumentFormats": "Supports PDF, images, and other document formats",
        "view": "Preview",
        "edit": "Edit",
        "delete": "Delete",
        "updateOrder": "Update order",
        "addUrlLink": "Add URL link",
        "addNote": "Add note",
        "pleaseEnterNote": "Please enter a note",
        "pleaseEnterPoNumber": "Please enter a PO number",
        "pleaseEnterDescription": "Please enter a description",
        "pleaseSelectTaxRate": "Please select a tax rate",
        "pleaseSelectCostCenter": "Please select a cost center",
        "pleaseSelectCostUnit": "Please select a cost unit",
        "pleaseSelectExpenseAccount": "Please select an expense account",
        "pleaseEnterLink": "Please enter a link",
        "totalNetAmountCannotBe0": "Total net amount cannot be 0",
        "totalGrossAmountCannotBe0": "Total gross amount cannot be 0",
        "pleaseEnterTotalVat": "Please enter a total VAT",
        "enableOcr": "Enable OCR",
        "removeFile": "Remove file",
        "pleaseSelectDateOfIssue": "Please select a date of issue",
        "pleaseSelectPerformancePeriod": "Please select a performance period",
        "pleaseSelectPerformanceDate": "Please select a performance date",
        "pleaseSelectVendor": "Please select a vendor",
        "pleaseSelectRequester": "Please select a requester",
        "pleaseSelectNextApprover": "Please select a next approver",
        "pleaseSelectCurrency": "Please select a currency",
        "pleaseSelectService": "Please select a service",
        "pleaseSelectUoM": "Please select a UoM",
        "totalTaxAmountCannotBe0": "Total tax amount cannot be 0",
        "startDate": "Start date",
        "endDate": "End date",
        "selectRequester": "Select requester",

        "costCenter2": "Cost center 2",

        "expectedServiceDate": "Performance date",
        "expectedDeliveryDate": "Expected delivery date"
    },

    "lineItemCard": {
        "pleaseEnterMaterialCode": "Please enter a material code",
        "pleaseEnterDescription": "Please enter a description",
        "pleaseEnterQuantity": "Please enter a quantity",
        "pleaseSelectUoM": "Please select a UoM",
        "pleaseEnterUnitPrice": "Please enter a unit price",
        "pleaseSelectTaxRate": "Please select a tax rate",
        "pleaseSelectCostCenter": "Please select a cost center",
        "pleaseSelectCostUnit": "Please select a cost unit",
        "pleaseSelectExpenseAccount": "Please select an expense account",
        "pleaseEnterLink": "Please enter a link",
        "pleaseEnterNote": "Please enter a note",
        "totalNetAmountCannotBe0": "Total net amount cannot be 0",
        "totalGrossAmountCannotBe0": "Total gross amount cannot be 0",
        "pleaseEnterTotalVat": "Please enter a total VAT",
        "enableOcr": "Enable OCR",
        "removeFile": "Remove file",
        "clickToUploadOrDragAndDropFilesHere": "Click to upload or drag and drop files here",
        "supportsPdfImagesAndOtherDocumentFormats": "Supports PDF, images, and other document formats",
        "view": "View"
    },
    "optionButtons": {
        "view": "View",
        "edit": "Edit",
        "delete": "Delete"
    },
    "delivery_location": {
        "loading": "Start typing, we will find your address..."
    },
    "linked_to_this_po": "Linked to this purchase order"
}
